import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
	// http://www.bentedder.com/create-a-pagination-component-in-angular-4/
	@Input() page: number; // the current page
	@Input() count: number; // how many total items there are in all pages
	@Input() perPage: number; // how many items we want to show per page
	//@Input() pagesToShow: number; // how many pages between next/prev
	@Input() loading: boolean; // check if content is being loaded

	@Output() goFirst = new EventEmitter<boolean>();
	@Output() goPrev = new EventEmitter<boolean>();
	@Output() goNext = new EventEmitter<boolean>();
	@Output() goLast = new EventEmitter<boolean>();
	@Output() goPage = new EventEmitter<number>();

	constructor() { }

	ngOnInit() {
	}

	getMin(): number {
		return ((this.perPage * this.page) - this.perPage) + 1;
	}

	getMax(): number {
		let max = this.perPage * this.page;
		if (max > this.count) {
			max = this.count;
		}
		return max;
	}

	onFirst(): void {
		if (!this.loading)
			this.goFirst.emit(true);
	}

	onPrev(): void {
		if (!this.loading)
			this.goPrev.emit(true);
	}

	onNext(next: boolean): void {
		if (!this.loading)
			this.goNext.emit(next);
	}

	onLast(next: boolean): void {
		if (!this.loading)
			this.goLast.emit(next);
	}

	onPage(n: number): void {
		this.goPage.emit(n);
	}

	totalPages(): number {
		return Math.ceil(this.count / this.perPage) || 0;
	}

	lastPage(): boolean {
		return this.perPage * this.page >= this.count;
	}

	/*getPages(): number[] {
		const c = Math.ceil(this.count / this.perPage);
		const p = this.page || 1;
		const pagesToShow = this.pagesToShow || 9;
		const pages: number[] = [];
		pages.push(p);
		const times = pagesToShow - 1;
		for (let i = 0; i < times; i++) {
			if (pages.length < pagesToShow) {
				if (Math.min.apply(null, pages) > 1) {
					pages.push(Math.min.apply(null, pages) - 1);
				}
			}
			if (pages.length < pagesToShow) {
				if (Math.max.apply(null, pages) < c) {
					pages.push(Math.max.apply(null, pages) + 1);
				}
			}
		}
		pages.sort((a, b) => a - b);
		return pages;
	}*/

}
